import type { Drawing } from '../shared/art/types';
import { drawingBackground, renderDrawing, renderDrawingStroke } from '../shared/art/drawing';

/** 教程仅有顺序笔画。完成的笔迹合成一次；半透明的当前笔从底图重绘，避免越播越深。 */
export class DrawingLessonReplay {
  private base: HTMLCanvasElement;
  private drawing?: Drawing;
  private completed = 0;
  private at = -1;
  constructor(createCanvas: (w: number, h: number) => HTMLCanvasElement, private size: number) { this.base = createCanvas(size, size); }
  render(ctx: CanvasRenderingContext2D, drawing: Drawing, position: number) {
    const base = this.base.getContext('2d')!, background = drawingBackground(drawing);
    if (drawing !== this.drawing || position < this.at) {
      renderDrawing(base, { schemaVersion: 1, background, strokes: [] }, this.size);
      this.drawing = drawing; this.completed = 0;
    }
    while (this.completed < drawing.strokes.length) {
      const stroke = drawing.strokes[this.completed];
      if (stroke.points.at(-1)!.t > position) break;
      renderDrawingStroke(base, stroke, this.size, background); this.completed++;
    }
    ctx.drawImage(this.base, 0, 0);
    const active = drawing.strokes[this.completed];
    if (active) renderDrawingStroke(ctx, active, this.size, background, position);
    this.at = position;
  }
}
